import type { MouseEvent } from 'react';
import { useUi } from '../state/ui';

/**
 * Open a database row: in a pop-up over the current view, or (Ctrl/Cmd-click,
 * middle click) as a page in a tab.
 */
export function openRow(pageId: string, e?: MouseEvent | { ctrlKey?: boolean; metaKey?: boolean }) {
  const ui = useUi.getState();
  if (e && (e.ctrlKey || e.metaKey)) ui.open({ kind: 'page', pageId }, true);
  else ui.set({ peekPageId: pageId });
}
